import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import { ActivityTypeSelector } from 'components/forms'

const messages = defineMessages({
  'activity_type_placeholder': {
    id: 'workouts.create.activity_type_placeholder',
    defaultMessage: 'Select an activity type',
  },
})

export function ActivitySelector ({ intl, ...props }) {
  return (
    <ActivityTypeSelector
      {...props}
      bold
      required
      name='activityType'
      placeholder={intl.formatMessage(messages.activity_type_placeholder)}
      errorComponent={(
        <FormattedMessage
          id='workouts.create.activity_type_required'
          defaultMessage='Activity type is required'
        />
      )}
      labelComponent={(
        <FormattedMessage
          id='workouts.create.activity_type'
          defaultMessage='Activity'
        />
      )}
    />
  )
}

ActivitySelector.propTypes = {
  intl: PropTypes.object,

}

export default injectIntl(ActivitySelector)



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/ActivitySelector.jsx